import React, { useEffect, useState, useRef } from 'react';
import { useScrollHeader, useIntoViewAnimation } from '../../hooks';
import Footer from "../../components/Footer/Footer";
import { Swiper, SwiperSlide } from 'swiper/react';
import './aboutUs.less';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/effect-coverflow';
import { FreeMode, Navigation, EffectCoverflow } from 'swiper/modules';

export default function AboutUs({ setHeaderDark }) {
  useScrollHeader(setHeaderDark, 50); // 50px 触发
  // 团队列表
  const teamList = [
    {
      name: '病理机制研究团队',
      member: ['中科院', '香港大学', '清华大学'],
      desc: '与中科院、香港大学、清华大学等顶尖机构强强联合，基于高分辨率fMRI利用功能磁共振从脑科学角度探究眼病病理机制，发现了眼病根本性损伤位点。',
      icon: '/images/home/teams1_icon_black.png',
    },
    {
      name: '临床试验团队',
      member: ['复旦眼科', '中山眼科', '温州眼视光医院'],
      desc: <>
        与复旦眼科、中山眼科、温州眼视光医院等国内头部眼科专家深度合作，打造真正符合临床患者真实需求的产品。<br />
        产品已进行60+预临床，临床效果得到了充分验证。
      </>,
      icon: '/images/home/teams2_icon_black.png',
    },
    {
      name: '产品开发及注册团队',
      member: ['AI', '可穿戴设备', '....'],
      desc: <>
        将创新病理机制研究成果与AI、可穿戴设备深度整合。<br />
        通过脑区损伤位点重塑打造效果更强、依从性更强、可及性更强的创新治疗范式。
      </>,
      icon: '/images/home/teams3_icon_black.png',
    },
  ]
  // 重要事件列表
  const eventData = [
    {
      date: '2024',
      desc: '集视医疗“视觉功能训练治疗软件”获批，用于弱视患者的临床治疗',
    },
    {
      date: '2022',
      desc: '苏州集视医疗科技有限公司正式成立，多项重磅学术成果商业化正式开始',
    },
    {
      date: '2021',
      desc: '在学术顶刊《Cell Report》上发表重磅文章《Loss and enhancement of layer-selective signals in geniculostriate and corticotectal pathways of adult human amblyopia》',
    },
    {
      date: '2017',
      desc: '首次双眼治疗尝试，并成为当年ARVO（美国视觉与研究协会）年会热点话题',
    },
    {
      date: '2015',
      desc: '全球首个提出弱视治疗“双机制”学说，获批国自然面上项目2项',
    },
    {
      date: '2013',
      desc: '发表《弱视神经损伤机制研究》中科院1区文章4篇 (Cell子刊，眼科顶刊等)',
    },
    {
      date: '2011',
      desc: '基于高分辨率功能磁共振建立了感知神经性眼病认知平台',
    },
  ]
  const [currentIndex, setCurrentIndex] = useState(0);
  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };
  const handleNext = () => {
    if (currentIndex < eventData.length - 3) {
      setCurrentIndex(currentIndex + 1);
    }
  };
  const isPrevDisabled = currentIndex === 0;
  const isNextDisabled = currentIndex >= eventData.length - 3;

  const [address, setAddress] = useState('杭州')
  const [hovered, setHovered] = useState(false)

  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setemail] = useState('');
  const [area, setArea] = useState('');
  const [demand, setDemand] = useState('');
  const handleSubmit = (e) => {
    e.preventDefault();
    const params = { name, phone, email, area, demand }
    console.log('params', params)
    // alert(`发送成功`);
  };

  const addressData = [
    {
      title: '苏州集视医疗科技有限公司',
      enTitle: 'Suzhou Focusight Medical Technology Co., Ltd',
      address: '中国(江苏)自由贸易试验区苏州片区苏州工业园区现代大道88号物流大厦',
      email: 'public@focusight.ltd',
    },
    {
      title: '杭州集视医疗科技有限公司',
      enTitle: 'Hangzhou Focusight Intelligent Technology Co., Ltd',
      address: '浙江省杭州市上城区源聚路299号钱涌白石中心2幢',
      email: 'public@focusight.ltd',
    },
  ]

  const contactList = [
    {
      title: '用户服务支持',
      desc: '提供专业的产品技术支持，可通过电话或电子邮箱获取及时服务',
      icon: '/images/aboutUs/Support_icon.png',
    },
    {
      title: '成为合作伙伴',
      desc: '与集视携手共拓市场蓝海',
      icon: '/images/aboutUs/Cooperation_icon.png',
    },
    {
      title: '加入我们',
      desc: '双轨晋升通道 / 定制化成长计划 / 弹性工作制',
      icon: '/images/aboutUs/Join_icon.png',
    },
  ]


  useEffect(() => {
    window.scrollTo(0, 0); // 进入页面时滚动到顶部
  }, []);

  // 跳转高德地图
  function openAmapWebByAddress(address) {
    var url = `https://ditu.amap.com/search?query=${encodeURIComponent(address)}`;
    window.open(url, '_blank');
  }

  // 公司团队 进入动画
  const teamsRef = useRef('')
  useIntoViewAnimation({
    ref: teamsRef,
    threshold: 0.1,
    className: 'teams--ani',
  })

  // 管线布局 进入动画
  const guanxianRef = useRef('')
  useIntoViewAnimation({
    ref: guanxianRef,
    threshold: 0.3,
    className: 'guanxian--ani',
  })

  // 重要事件 进入动画
  const historyRef = useRef('')
  useIntoViewAnimation({
    ref: historyRef,
    threshold: 0.3,
    className: 'history--ani',
  })

  // 合作单位 进入动画
  const partnerRef = useRef('')
  useIntoViewAnimation({
    ref: partnerRef,
    threshold: 0.5,
    className: 'partner--ani',
  })

  // 联系我们 进入动画
  const contactRef = useRef('')
  useIntoViewAnimation({
    ref: contactRef,
    threshold: 0.3,
    className: 'contact--ani',
  })

  // 和我们取得联系 进入动画
  const contactUsRef = useRef('')
  useIntoViewAnimation({
    ref: contactUsRef,
    threshold: 0.3,
    className: 'contactUs--ani',
  })

  // 地址 进入动画
  const addressRef = useRef('')
  useIntoViewAnimation({
    ref: addressRef,
    threshold: 0.3,
    className: 'address--ani',
  })

  return <div>
    <div className='AboutUs_cover flex_center ta_c'>
      <div className='of_hidden'>
        <div className='AboutUs_cover-content c_ff'>
          <div className="AboutUs_cover-title">了解集视医疗</div>
          <div className="AboutUs_cover-titleEn">About Focusight®</div>
        </div>
      </div>
    </div>
    <div className="AboutUs_section1">
      <div className="pageMargin">
        <div className="AboutUs_section1-top">
          <div className="AboutUs_section1-logo flex_col flex_ai-c">
            <img
              src='/images/footer.svg'
              alt=''
            />
          </div>
          <div className="AboutUs_section1-topBlock flex_col flex_ai-c">
            <div className='AboutUs_section1-topText'>
              <div className="AboutUs_section1-topTitle">杭州集视智能科技有限公司</div>
              <div className="AboutUs_section1-topDesc">
                集视医疗是一家专注于眼科医疗器械的创新型企业。致力于从底层脑科学+眼病机制研究+可穿戴智能化产品突破传统干预手段年龄、效果、地点、依从性等限制，提高眼病患者干预效果及可及性。<br /><br />
                公司以脑科学研究为基础载体运用领先的物联网、人工智能与大数据云计算技术，打通院内外及患者全时空全病程数据，全面赋能眼科疾病的诊断、治疗及诊后管理。
              </div>
            </div>
          </div>
        </div>
        <div className='AboutUs_section1-team'>
          <div ref={teamsRef}>
            <div className='AboutUs_section1-teamTop'>
              <div className="AboutUs_section1-teamTitle">公司团队</div>
              <div className="AboutUs_section1-teamTitleEn">Focusight® Teams</div>
            </div>
            <div className="AboutUs_section1-teamBlock">
              {teamList.map((item) => <div className='AboutUs_section1-item'>
                <div className='AboutUs_content-itemBlock flex_col flex_ai-c'>
                  <img
                    className='AboutUs_content-itemIcon'
                    src={item.icon}
                    alt=''
                  />
                  <div className="AboutUs_content-itemName">{item.name}</div>
                  {item.member.map((i) => <div className='AboutUs_content-itemMember'>
                    {i}
                  </div>)}
                </div>
                <div className="AboutUs_content-itemDesc">{item.desc}</div>
              </div>)}
            </div>
          </div>
        </div>
        <div className='AboutUs_section1-bottom'>
          <div ref={guanxianRef}>
            {/* PC端 */}
            <div className="AboutUs_section1-imgPc flex_col flex_ai-c">
              <img
                style={{ width: '80%' }}
                src='/images/aboutUs/guanxian.svg'
                alt=''
              />
            </div>
            {/* 移动端 */}
            <div className="AboutUs_section1-imgMobile flex_col flex_ai-c">
              <img
                style={{ width: '75%' }}
                src='/images/aboutUs/guanxian-390.png'
                alt=''
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ref={historyRef} className="AboutUs_section2">
      <div className="pageMargin of_hidden">
        <div className='AboutUs_section2-historyTop c_ff'>
          <div className="AboutUs_section1-teamTitle">重要事件</div>
          <div className="AboutUs_section1-teamTitleEn">Focusight® Development history</div>
        </div>
        {/* Pc端 */}
        <div className="AboutUs_section2-blockPc">
          <Swiper
            slidesPerView={3}
            spaceBetween={16}
            freeMode={true}
            navigation={{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }}
            modules={[FreeMode, Navigation]}
            className="mt_74"
          >
            {eventData.map((item, index) => <SwiperSlide key={index}>
              <div className="AboutUs_section2-item ">
                <div className="text fz_80 fw_700 lh_94 c_ff mt_30 ml_47 mr_45">{item.date}</div>
                <div className="fz_16 fw_500 lh_24 c_ff ml_47 mr_62 pb_30">{item.desc}</div>
              </div>
            </SwiperSlide>)}
            {/* 自定义导航按钮 */}
            <div className='mt_40 pb_20 flex_row flex_jc-c gap_40'>
              <div
                className={`swiper-button-prev flex_center ${isPrevDisabled ? 'disabled' : ''}`}
                onClick={handlePrev}
              >
                <img
                  className='Wearable_product-sliderBtnIcon'
                  src='./images/home/whiteLeftIcon.png'
                  alt=''
                />
              </div>
              <div
                className={`swiper-button-next flex_center ${isNextDisabled ? 'disabled' : ''}`}
                onClick={handleNext}
              >
                <img
                  className='Wearable_product-sliderBtnIcon'
                  src='./images/home/whiteRightIcon.png'
                  alt=''
                />
              </div>
            </div>
          </Swiper>
        </div>
        {/* 移动端 */}
        <div className='AboutUs_section2-blockMobile mt_20' style={{ width: '100%', height: '500px' }}>
          <Swiper
            direction={'vertical'}
            effect={'coverflow'}
            slidesPerView={3}  //始终显示 3 条数据
            initialSlide={1} // 默认选中第2项（索引为1）
            grabCursor={true}
            centeredSlides={true} // 当前项居中
            spaceBetween={10}
            coverflowEffect={{
              rotate: 0,       // 禁用旋转
              stretch: 0,      // 禁用拉伸
              depth: 0,        // 禁用深度
              modifier: 1,
              slideShadows: false, // 禁用阴影
            }}
            modules={[EffectCoverflow]}
            className="About_Swiper"
          >
            {eventData.map((item, index) => <SwiperSlide key={index}>
              <div className="flex_center c_ff" style={{ height: '160px' }}>
                <div className="text fz_36 fw_700 lh_42">{item.date}</div>
                <div className="fz_10 fw_500 lh_12 ml_50 mr_50 mt_6 ta_c">{item.desc}</div>
              </div>
            </SwiperSlide>)}
          </Swiper>
        </div>
      </div>
    </div>
    <div className="AboutUs_section3">
      <div className="pageMargin">
        <div ref={partnerRef}>
          <div className='AboutUs_section3-partnerTop'>
            <div className="AboutUs_section1-teamTitle">眼科深度战略合作单位(排名不分先后)</div>
            <div className="AboutUs_section1-teamTitleEn">Focusight® Cooperative Partner</div>
          </div>
          {/* PC端 */}
          <div className="AboutUs_section3-partnerImgPc mt_40 flex_col flex_ai-c">
            <img
              style={{ width: '80%' }}
              src='/images/aboutUs/work-1920.png'
              alt=''
            />
          </div>
          {/* 移动端 */}
          <div className="AboutUs_section3-partnerImgMobile mt_15 flex_col flex_ai-c">
            <img
              style={{ width: '100%' }}
              src='/images/aboutUs/work-390.png'
              alt=''
            />
          </div>
        </div>
        <div ref={contactRef}>
          <div className='AboutUs_section3-contactTop'>
            <div className="AboutUs_section1-teamTitle">联系我们</div>
            <div className="AboutUs_section1-teamTitleEn">Contact Focusight®</div>
          </div>
          <div className="AboutUs_section3-contactBlock">
            {contactList.map((item, index) => <div key={index} className="AboutUs_section3-item">
              <div className="AboutUs_section3-itemBlock flex_col flex_ai-c">
                <img
                  className='AboutUs_section3-itemIcon'
                  src={item.icon}
                  alt=''
                />
                <div className="AboutUs_section3-itemTitle ta_c">{item.title}</div>
                <div className="AboutUs_section3-itemDesc c_85899E ta_c">{item.desc}</div>
              </div>
            </div>)}
          </div>
        </div>
        <div className="of_hidden">
          <div ref={contactUsRef} className='AboutUs_section3-contactUsBlock'>
            <div className='AboutUs_section3-contactUsLeft'>
              <div className="AboutUs_section3-contactUsTitle">和我们取得联系</div>
              <div className="AboutUs_section3-contactUsDesc mt_10 c_85899E" style={{ maxWidth: '372px' }}>如果您在我们的常见问题解答中找不到您的问题的答案，您可以随时联系我们。 我们会尽快回复您！</div>
              {/* PC端 */}
              <form
                className="AboutUs_section3-formPc"
                onSubmit={handleSubmit}
              >
                <div className="input-with-icon name-icon">
                  <input
                    className="AboutUs_section3-input"
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="您的姓名"
                  />
                  <div className='AboutUs_section3-inputLine'></div>
                </div>
                <div className="input-with-icon phone-icon">
                  <input
                    className="AboutUs_section3-input"
                    type="text"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder="您的电话"
                  />
                  <div className='AboutUs_section3-inputLine'></div>
                </div>
                <div className="input-with-icon email-icon">
                  <input
                    className="AboutUs_section3-input"
                    type="text"
                    value={email}
                    onChange={(e) => setemail(e.target.value)}
                    placeholder="您的邮箱"
                  />
                  <div className='AboutUs_section3-inputLine'></div>
                </div>
                <div className="input-with-icon address-icon">
                  <input
                    className="AboutUs_section3-input"
                    type="text"
                    value={area}
                    onChange={(e) => setArea(e.target.value)}
                    placeholder="所在地区"
                  />
                  <div className='AboutUs_section3-inputLine'></div>
                </div>
                <div className="input-with-icon demand-icon">
                  <input
                    className="AboutUs_section3-input"
                    type="text"
                    value={demand}
                    onChange={(e) => setDemand(e.target.value)}
                    placeholder="请描述您的需求"
                  />
                  <div className='AboutUs_section3-inputLine'></div>
                </div>
                <button
                  type="submit"
                  className="AboutUs_section3-btn"
                  onMouseEnter={() => setHovered(true)}
                  onMouseLeave={() => setHovered(false)}
                >
                  发送消息
                  <img
                    className='Wearable_product-rightArrow'
                    src={hovered ? './images/home/arrow-right-whiteLine.png' : './images/home/arrow-right-blackLine.png'}
                    alt=''
                  />
                </button>
              </form>
              {/* 移动端 */}
              <form
                className="AboutUs_section3-formMobile flex_col flex_ai-c gap_12 ta_c mt_17"
                onSubmit={handleSubmit}
              >
                <input
                  className="AboutUs_section3-inputMobile"
                  type="text"
                  name='neme'
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="您的姓名"
                />
                <input
                  className="AboutUs_section3-inputMobile"
                  type="text"
                  name='phone'
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  placeholder="您的电话"
                />
                <input
                  className="AboutUs_section3-inputMobile"
                  type="text"
                  name='email'
                  value={email}
                  onChange={(e) => setemail(e.target.value)}
                  placeholder="您的邮箱"
                />
                <input
                  className="AboutUs_section3-inputMobile"
                  type="text"
                  name='area'
                  value={area}
                  onChange={(e) => setArea(e.target.value)}
                  placeholder="所在地区"
                />
                <textarea
                  className="AboutUs_section3-inputMobile"
                  name="demand"
                  value={demand}
                  onChange={(e) => setDemand(e.target.value)}
                  placeholder="请描述您的需求"
                />
                <button
                  type="submit"
                  className="AboutUs_section3-btn"
                  onMouseEnter={() => setHovered(true)}
                  onMouseLeave={() => setHovered(false)}
                >
                  发送消息
                  <img
                    className='Wearable_product-rightArrowMobile'
                    src={hovered ? './images/home/arrow-right-whiteLine.png' : './images/home/arrow-right-blackLine.png'}
                    alt=''
                  />
                </button>
              </form>
            </div>
            <div className="AboutUs_section3-img">
              <div className="flex_row gap_16">
                <div
                  className={`AboutUs_section3-imgBtn flex_center ${address === '杭州' ? 'active' : ''}`}
                  onClick={() => setAddress('杭州')}
                >杭州公司</div>
                <div
                  className={`AboutUs_section3-imgBtn flex_center ${address === '苏州' ? 'active' : ''}`}
                  onClick={() => setAddress('苏州')}
                >苏州公司</div>
              </div>
              <img
                src={address === '杭州' ? '/images/aboutUs/address1.png' : '/images/aboutUs/address2.png'}
                alt=''
                onClick={() =>
                  openAmapWebByAddress(address === '杭州' ?
                    '浙江省杭州市上城区源聚路299号钱涌白石中心2幢'
                    :
                    '苏州物流大厦')
                }
              />
            </div>
          </div>
        </div>
        <div ref={addressRef} className="AboutUs_section3-bottom of_hidden">
          {addressData.map((item, index) => <div key={index} className="AboutUs_section3-bottomItem">
            <div className="AboutUs_section3-bottomItemBlock c_ff">
              <div className="AboutUs_section3-bottomItemTitle">{item.title}</div>
              <div className="AboutUs_section3-bottomItemTitleEn">{item.enTitle}</div>
              <div className="AboutUs_section3-bottomAddress flex_col flex_jc-sb gap_16">
                <div className="flex_row flex_ai-c">
                  <div className="AboutUs_section3-bottomIcon flex_center flex_auto">
                    <img
                      className="AboutUs_section3-bottomImg"
                      src='/images/aboutUs/work_add_icon.png'
                      alt=''
                    />
                  </div>
                  <div className="AboutUs_section3-bottomItemAddress flex_full">{item.address}</div>
                </div>
                <div className="flex_row flex_ai-c">
                  <div className="AboutUs_section3-bottomIcon flex_center flex_auto">
                    <img
                      className="AboutUs_section3-bottomImg"
                      src='/images/aboutUs/work_email_icon.png'
                      alt=''
                    />
                  </div>
                  <div className="AboutUs_section3-bottomItemAddress flex_full">{item.email}</div>
                </div>
              </div>
            </div>
          </div>)}
        </div>
      </div>
    </div>
    <Footer />
  </div >
}
